/**
 * Shared utility functions for challenges table
 */

/**
 * Check if endDate is from the previous year (local time)
 */
export function isEndDatePreviousYear(
  endDate: string | null | undefined,
): boolean {
  if (!endDate) return false;
  const end = new Date(endDate);
  const now = new Date();
  return end.getFullYear() === now.getFullYear() - 1;
}
